import AnswerBodyCTA from '../../answers/AnswerBodyCTA';
import AnswerTrialCard from '../../answers/AnswerTrialCard';
import AnswerSocialProof from '../../answers/AnswerSocialProof';
import {
  ANSWERS_VALUE_PROP_BLOCK_NAME,
  AnswersValuePropArgs,
  bodyCtaSchema,
  socialProofSchema,
  trialCtaSchema,
  trialCardSchema,
} from '../../../lib/composer/schemas/answersValueProp';

/**
 * Global editable copy for the answer-page value-prop sections. A single config
 * page holds one of these blocks; answer pages read its args (see
 * `getAnswersValueProp` in app/answers/util.ts) and thread them into the real
 * components. Here it just renders the three sections stacked so editors get a
 * live preview inside the composer (previewMode bypasses the logged-out guard).
 */
const AnswersValueProp = (props: AnswersValuePropArgs) => (
  <div className="mx-auto flex max-w-md flex-col gap-4 p-4">
    <AnswerBodyCTA cta={props.bodyCta} trialCta={props.trialCta ?? {}} />
    <AnswerTrialCard
      config={props.trialCard}
      trialCta={props.trialCta}
      previewMode
    />
    <AnswerSocialProof config={props.socialProof} previewMode />
  </div>
);

AnswersValueProp.schema = {
  name: ANSWERS_VALUE_PROP_BLOCK_NAME,
  label: 'Answers Value Prop',
  editableProps: [
    trialCtaSchema,
    bodyCtaSchema,
    trialCardSchema,
    socialProofSchema,
  ],
};

export default AnswersValueProp;
